export const GET_LIST_PHIKHAC = "GET_LIST_PHIKHAC";
export const GET_LIST_PHIKHAC_SUCCESS = "GET_LIST_PHIKHAC_SUCCESS";
export const GET_LIST_PHIKHAC_FAILURE = "GET_LIST_PHIKHAC_FAILURE";
export const GET_LIST_PHIKHAC_CHOVAY = "GET_LIST_PHIKHAC_CHOVAY";
export const GET_LIST_PHIKHAC_CHOVAY_SUCCESS =
  "GET_LIST_PHIKHAC_CHOVAY_SUCCESS";
export const GET_LIST_PHIKHAC_CHOVAY_FAILURE =
  "GET_LIST_PHIKHAC_CHOVAY_FAILURE";
